import {
  GET_ADMIN_TWILIO_NUMBERS,
  GET_ADMIN_TWILIO_NUMBERS_SUCCESS,
  GET_ADMIN_TWILIO_NUMBERS_ERROR,
  DELETE_ADMIN_TWILIO_NUMBER,
  DELETE_ADMIN_TWILIO_NUMBER_SUCCESS,
  DELETE_ADMIN_TWILIO_NUMBER_ERROR,
  EXPORT_ADMIN_TWILIO_NUMBERS,
  EXPORT_ADMIN_TWILIO_NUMBERS_SUCCESS,
  EXPORT_ADMIN_TWILIO_NUMBERS_ERROR
} from "./actionTypes"

// Actions
export const getAdminTwilioNumbers = (query_params, paginated) => ({
  type: GET_ADMIN_TWILIO_NUMBERS,
  payload: query_params,
  paginated: paginated
})

export const getAdminTwilioNumbersSuccess = (numbers, meta = {}) => ({
  type: GET_ADMIN_TWILIO_NUMBERS_SUCCESS,
  payload: numbers,
  meta,
})

export const getAdminTwilioNumbersError = () => ({
  type: GET_ADMIN_TWILIO_NUMBERS_ERROR,
})

export const deleteAdminTwilioNumber = (payload) => ({
  type: DELETE_ADMIN_TWILIO_NUMBER,
  payload: payload,
})

export const deleteAdminTwilioNumberSuccess = (data) => ({
  type: DELETE_ADMIN_TWILIO_NUMBER_SUCCESS,
  payload: data,
})

export const deleteAdminTwilioNumberError = () => ({
  type: DELETE_ADMIN_TWILIO_NUMBER_ERROR,
})

export const exportAdminTwilioNumbers = (query_params) => ({
  type: EXPORT_ADMIN_TWILIO_NUMBERS,
  payload: query_params,
})

export const exportAdminTwilioNumbersSuccess = () => ({
  type: EXPORT_ADMIN_TWILIO_NUMBERS_SUCCESS,
})

export const exportAdminTwilioNumbersError = (error) => ({
  type: EXPORT_ADMIN_TWILIO_NUMBERS_ERROR,
  payload: error,
})
